import { useEffect, useState } from 'react'
import Image from 'react-bootstrap/Image'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import BellIcon from '../../assets/icons/common/bell.svg'
import { NotificationsService, TicketsService } from '../../services'
import { useDispatch, useSelector } from 'react-redux'
import { PAGINATION_TYPES } from '../../utils/constants'
// import { updatePaginationItem } from '../../store/reducers'
import getPaginationData from '../../store/actions/pagination'
import {
  requestNotificationPermission,
  sendNotification,
} from '../../utils/helperFunctions'

function ButtonsSection() {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { items, currentPage, rowsPerPage, total, total_unseen_ticket_count } =
    useSelector(({ pagination }) => pagination[PAGINATION_TYPES.TICKETS])
  // const [notifications, setNotifications] = useState([])
  useEffect(() => {
    let interval

    check_notification()
    interval = setInterval(() => {
      check_notification()
    }, 10000)

    return () => clearInterval(interval)
  }, [])

  // useEffect(() => {
  //   requestNotificationPermission()
  // }, [])

  const handleClick = () => {
    sendNotification('You have a message!', {
      body: 'Please check your ticket list',
      icon: 'https://cdn-icons-png.flaticon.com/512/733/733533.png', // Optional icon
    })
  }

  const check_notification = async () => {
    try {
      const response = await NotificationsService.check_notification()
      if (response?.has_unseen_message) {
        // setNotifications(response)
        // dispatch(
        //   updatePaginationItem({
        //     id,
        //     primaryKey,
        //     key,
        //     value,
        //   }),
        // )
        // handleClick()
        dispatch(
          getPaginationData({
            key: PAGINATION_TYPES.TICKETS,
            ServiceName: TicketsService,
            page: currentPage,
            per_page: rowsPerPage,
            order_by: 'desc',
            loading: false,
            // ...searchQuery,
          }),
        )
      }
    } catch (error) {}
  }
  return (
    <div className='d-flex align-items-center'>
      <div
        className='navbar-link position-relative pointer'
        onClick={() => location.pathname !== '/ticket' && navigate('/ticket')}
      >
        <Image src={BellIcon} />
        <div
          className='bg-danger text-center d-flex align-items-center justify-content-center'
          style={{
            position: 'absolute',
            top: -2,
            right: -5,
            color: 'white',
            height: '15px',
            width: '15px',
            borderRadius: '50%',
            fontSize: 8,
          }}
        >
          {/* {items.reduce(
            (total_, item) => total_ + item?.unseen_message_count,
            0,
          )} */}
          {total_unseen_ticket_count || 0}
        </div>
      </div>
    </div>
  )
}

export default ButtonsSection
